import React from "react"

import { ProjectAttachmentsModel } from "widgets/project-attachments/ProjectAttachments"

import { ProjectAttachmentsOverlayView } from "./ProjectAttachmentsOverlayView"

interface ProjectAttachmentsOverlayProps {
  attachmentsModel: ProjectAttachmentsModel
}

export const ProjectAttachmentsOverlay = React.memo(
  (props: ProjectAttachmentsOverlayProps) => {
    return <ProjectAttachmentsOverlayView {...props} />
  }
)
